import { MilestoneType } from 'types';

export enum AccountMilestoneStatus {
  completed = 'completed',
  inProgress = 'inProgress',
  pending = 'pending',
  rejected = 'rejected',
  submitted = 'submitted',
}

export enum AccountRequirementStatus {
  completed = 'completed',
  inProgress = 'inProgress',
  pending = 'pending',
  rejected = 'rejected',
  submitted = 'submitted',
  error = 'error',
}

export const milestoneTypeToEmailStringMap: { [value in MilestoneType]?: 'Install' | 'Activation' } = {
  [MilestoneType.install]: 'Install',
  [MilestoneType.activation]: 'Activation',
};

export enum MilestonePackageActions {
  create = 'create',
  edit = 'edit',
  review = 'review',
}
